var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 173,
    height: 87,
    viewBox: "0 0 173 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_12765",
    "data-name": "Rettangolo 12765",
    width: 173,
    height: 87,
    transform: "translate(1226 1632)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23028",
    "data-name": "Raggruppa 23028",
    transform: "translate(-1235 -1639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23017",
    "data-name": "Raggruppa 23017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_245",
    "data-name": "Gruppo di maschere 245",
    transform: "translate(9 7)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_33429",
    "data-name": "Tracciato 33429",
    transform: "translate(1240 1641)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 72.5 137 C 36.93457794189453 137 8 108.0654220581055 8 72.5 C 8 36.93457794189453 36.93457794189453 8 72.5 8 C 108.0654220581055 8 137 36.93457794189453 137 72.5 C 137 108.0654220581055 108.0654220581055 137 72.5 137 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.5 16 C 41.34578704833984 16 16 41.34578704833984 16 72.5 C 16 103.6542129516602 41.34578704833984 129 72.5 129 C 103.6542129516602 129 129 103.6542129516602 129 72.5 C 129 41.34578704833984 103.6542129516602 16 72.5 16 M 72.5 0 C 112.540641784668 0 145 32.45935821533203 145 72.5 C 145 112.540641784668 112.540641784668 145 72.5 145 C 32.45935821533203 145 0 112.540641784668 0 72.5 C 0 32.45935821533203 32.45935821533203 0 72.5 0 Z",
    stroke: "none",
    fill: "#e5e5e5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_22296",
    "data-name": "Raggruppa 22296"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1532",
    "data-name": "Ellisse 1532",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(1315 1711)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_12767",
    "data-name": "Rettangolo 12767",
    width: 7.409,
    height: 7.409,
    transform: "translate(1316.261 1713.625) rotate(-45)",
    fill: "#b8b8b8"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_1945",
    "data-name": "< 1945",
    transform: "matrix(0.391, -0.921, 0.921, 0.391, 1264.301, 1699.477)",
    fontSize: 9,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13,
    y: 0
  }, "&lt; 1945")), /*#__PURE__*/React.createElement("text", {
    id: "_1945-1980",
    "data-name": "1945-1980",
    transform: "translate(1321 1660)",
    fontSize: 9,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21,
    y: 0
  }, "1945-1980")), /*#__PURE__*/React.createElement("text", {
    id: "_1980",
    "data-name": "> 1980",
    transform: "translate(1378.65 1699.355) rotate(70)",
    fontSize: 9,
    fontFamily: "Ubuntu-Bold, Ubuntu",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13,
    y: 0
  }, "&gt; 1980")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph2);
export default __webpack_public_path__ + "static/media/graph2.46bc5a560996140070c69fa6dc3bee44.svg";
export { ForwardRef as ReactComponent };